import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Fade } from 'react-reveal'
import {
  TricolorOuter,
  TricolorCard,
  TricolorWrapper,
  Bullets,
  Bullet,
  IconWrapper,
} from './Tricolor.styles'

const Tricolor = ({ content }) => (
  <TricolorOuter>
    <TricolorWrapper>
      {content.map((card) => (
        <TricolorCard key={uuidv4()}>
          <h3>{card.head}</h3>
          <Bullets>
            {card.points.map((point, i) => (
              <Bullet key={uuidv4()}>
                <Fade top delay={i * 100 + 100}>
                  <IconWrapper>{point.icon}</IconWrapper>
                </Fade>
                <p>{point.text}</p>
              </Bullet>
            ))}
          </Bullets>
        </TricolorCard>
      ))}
    </TricolorWrapper>
  </TricolorOuter>
)

export default Tricolor
